import classNames from "classnames";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import { PropsWithChildren } from "react";
import { Theme } from "../../config/themes";
import "./style.scss";

export interface GridCellCommonProps {
  id?: string;
  cellSize?: "1x1" | "1x2" | "2x1" | "2x2" | "3x3";
  theme?: Theme;
  requiresFeature?: string;
  className?: string;
  bkgColor?: string;
}

const GridCell = ({
  id,
  className,
  theme = "white",
  bkgColor,
  requiresFeature,
  cellSize = "1x1",
  children,
  ...unhandledProps
}: PropsWithChildren<GridCellCommonProps>) => {
  console.log("GridCell className", className);
  const features = useSiteFeatures();
  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <div
      id={id}
      className={classNames("grid-cell-wrapper", "grid-cell-size-" + cellSize)}
    >
      <div
        id={id}
        className={classNames("grid-cell", "theme-" + theme, className)}
        style={{ backgroundColor: bkgColor }}
        {...unhandledProps}
      >
        {children}
      </div>
    </div>
  ) : null;
};

export default GridCell;
